// React import removed
import { Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

const HomePage: React.FC = () => {
  const { isAuthenticated, user } = useAuth()

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900">
              St. Mary's Coptic Orthodox Church
            </h1>
            <p className="mt-4 text-xl sm:text-2xl text-gray-600">
              Annual Mahragan Competition Portal
            </p>
            <p className="mt-6 max-w-3xl mx-auto text-lg text-gray-500">
              Welcome to our comprehensive competition management system. 
              Register for competitions, track your progress, and celebrate 
              achievements in our spiritual and athletic tournaments.
            </p>
            
            {!isAuthenticated ? (
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/register"
                  className="btn-primary text-lg px-8 py-3"
                >
                  Register Now
                </Link>
                <Link
                  to="/login"
                  className="btn-outline text-lg px-8 py-3"
                >
                  Login
                </Link>
              </div>
            ) : (
              <div className="mt-8">
                <p className="text-lg text-gray-700 mb-4">
                  Welcome back, {user?.firstName}!
                </p>
                {user?.role === 'super_admin' && (
                  <Link
                    to="/admin"
                    className="btn-primary text-lg px-8 py-3 mr-4"
                  >
                    Admin Dashboard
                  </Link>
                )}
                <Link
                  to="/competitions"
                  className="btn-outline text-lg px-8 py-3"
                >
                  View Competitions
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-12">
              Competition Categories
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: 'Coptic Hymns',
                description: 'Traditional hymn competitions across different age groups',
                icon: '🎵'
              },
              {
                title: 'Spiritual Competitions',
                description: 'Bible knowledge and spiritual understanding contests',
                icon: '📖'
              },
              {
                title: 'Sports Tournaments',
                description: 'Soccer, volleyball, chess, and ping pong competitions',
                icon: '⚽'
              },
              {
                title: 'Art & Creativity',
                description: 'Creative expression and artistic talent showcases',
                icon: '🎨'
              }
            ].map((category, index) => (
              <div key={index} className="text-center p-6 bg-gray-50 rounded-lg">
                <div className="text-4xl mb-4">{category.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {category.title}
                </h3>
                <p className="text-gray-600">
                  {category.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="py-16 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {[
              { label: 'Participating Churches', value: '25+' },
              { label: 'Annual Participants', value: '500+' },
              { label: 'Competition Categories', value: '15+' }
            ].map((stat, index) => (
              <div key={index} className="text-white">
                <div className="text-4xl font-bold mb-2">{stat.value}</div>
                <div className="text-xl">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 bg-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Ready to Participate?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Join hundreds of participants in this year's Mahragan competition. 
            Register your church and start your journey today.
          </p>
          
          {!isAuthenticated && (
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/register"
                className="btn-primary text-lg px-8 py-3"
              >
                Get Started
              </Link>
              <Link
                to="/churches"
                className="btn-outline text-lg px-8 py-3"
              >
                View Churches
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default HomePage